module.exports = __webpack_public_path__ + "static/raluca_diana-1f10970678dfd8ea4cd3a5f029c01830.jpg";